import Card from "./card"

const CardBlock = ({ blok, isRTDPage }) => {
	const cards = blok.cards
	const countPerRow = parseInt(blok.countPerRow, 10) || 4 // Default to 4 columns

	// Map countPerRow to grid columns (supports up to 6 columns)
	const getGridCols = () => {
		const effectiveCount = countPerRow > 6 ? 6 : countPerRow
		switch (effectiveCount) {
			case 1:
				return "grid-cols-1"
			case 2:
				return "grid-cols-1 md:grid-cols-2"
			case 3:
				return "grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
			case 4:
				return "grid-cols-1 md:grid-cols-2 lg:grid-cols-4"
			case 5:
				return "grid-cols-1 md:grid-cols-3 lg:grid-cols-5"
			case 6:
				return "grid-cols-2 md:grid-cols-3 lg:grid-cols-6"
			default:
				return "grid-cols-1 md:grid-cols-2 lg:grid-cols-4"
		}
	}

	// Use minimal margins for 5 or 6 columns to maximize width
	const wrapperClasses =
		countPerRow >= 5
			? "md:flex md:flex-wrap md:justify-center md:items-center md:h-full max-w-full md:pt-2 md:pb-2"
			: "md:flex md:flex-wrap md:justify-center md:items-center md:h-full max-w-full md:mx-4 md:pt-2 md:pb-2"

	// Reduce horizontal padding when there are many cards per row
	const gridPaddingClasses = countPerRow >= 5 ? "px-0 md:px-4" : "px-4"

	return (
		<div className={wrapperClasses}>
			<div className={`grid ${getGridCols()} gap-4 w-full ${gridPaddingClasses}`}>
				{cards.map((card, index) => (
					<Card blok={card} key={index} isRTDPage={isRTDPage} />
				))}
			</div>
		</div>
	)
}

export default CardBlock
